/* eslint-disable no-underscore-dangle */
import SearchClient from '../search';

export default class SmsClient extends SearchClient {
  constructor(options = {}) {
    super(options);
  }

  sendSMS = async (code, mobilePhone) => {
    try {
      await this.request('post')(
        {
          code, mobilePhone,
        },
        { path: '/sms/send' },
      );
      return 'OK';
    } catch (error) {
      console.log(error);
      return 'KO';
    }
  }
}
